import {fuzzyScore} from '@github-ui/fuzzy-filter'
import type {Suggestions} from '@github-ui/inline-autocomplete/types'
import {ActionList} from '@primer/react'
import {useMemo} from 'react'

import type {AvailableCommand} from '../../hooks/use-available-commands'

export interface CommandsQuery {
  category: 'commands'
  filter: string
}

export function useCommandsSuggestions(
  availableCommands: AvailableCommand[],
  query: CommandsQuery | null,
): Suggestions | null {
  const suggestions = useMemo<Suggestions | null>(() => {
    if (!query) return null

    const filteredCommands =
      query.filter.trim() === ''
        ? availableCommands
        : availableCommands.filter(
            command => fuzzyScore(command.name, query.filter) > 0.5 && command.key !== query.filter.toLowerCase(),
          )

    return filteredCommands.map(command => ({
      value: `/${command.key}`,
      key: command.key,
      render: props => (
        <ActionList.Item {...props}>
          <ActionList.LeadingVisual>
            <command.icon />
          </ActionList.LeadingVisual>
          {command.name}
          <ActionList.Description variant="block">{command.description}</ActionList.Description>
        </ActionList.Item>
      ),
    }))
  }, [availableCommands, query])

  return suggestions
}
